import React from "react";
import "./Hero.scss";
import heroImg from "../../images/hero.jpg";

const Hero = () => {
  return (
    <section className="hero" id="inicio">
      <div className="container">
        <div className="hero__wrapper">
          <div className="hero__content">
            <div className="hero__badge">
              <span className="hero__badge-dot"></span>
              <span>Maquinaria industrial para potenciar tu producción</span>
            </div>

            <h1 className="hero__title">
              Equipos industriales para empresas que buscan
              <span> productividad, precisión y rendimiento.</span>
            </h1>

            <p className="hero__description">
              En Makinaria Dima ofrecemos maquinaria industrial especializada,
              incluyendo equipos CNC y otras soluciones para optimizar procesos
              de fabricación, producción y trabajo industrial con atención
              profesional y cobertura a todo México.
            </p>

            <div className="hero__actions">
              <a
                href={`https://wa.me/525515898591?text=${encodeURIComponent(
                  "Hola, me gustaría recibir más información sobre su maquinaria industrial."
                )}`}
                target="_blank"
                rel="noopener noreferrer"
                className="header__cta"
              >
                Solicitar información
              </a>

              <a href="#catalogo" className="hero__btn hero__btn--secondary">
                Ver catálogo
              </a>
            </div>
          </div>

          <div className="hero__visual">
            <div className="hero__image-frame">
              <img
                src={heroImg}
                alt="Maquinaria industrial"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Hero;